import HorizontalGridLabels from "../Pulsar/components/HorizontalGridLabels";
import HorizontalGrid from "../Pulsar/components/HorizontalGrid";
import FilterContainer from "../Pulsar/components/Filters/FilterContainer";
import dnaOverlay from "../Pulsar/tracks/dna/DnaOverlay";
import dnaTrackController from "../Pulsar/tracks/dna/dnaTrackController";
import CnvCallTooltip from "../Pulsar/tracks/cnvCalls/components/CnvCallTooltip";
import CnvCallTitle from "../Pulsar/tracks/cnvCalls/components/CnvCallTitle";
import readTrackController from "../Pulsar/tracks/reads/readTrackController";
import callTrackController from "../Pulsar/tracks/cnvCalls/callTrackController";
import coverageTrackController from "../Pulsar/tracks/readCoverage/coverageTrackController";
import CoverageOverlay from "../Pulsar/tracks/readCoverage/CoverageOverlay";
import getApiClient from "../Pulsar/apiClient";
import ReadTooltip from "../Pulsar/tracks/reads/components/ReadTooltip";
import ReadTitle from "../Pulsar/tracks/reads/components/ReadTitle";

import selectionTrackController from "../Pulsar/tracks/selection/selectionTrackController";
import RohTitle from "../Pulsar/tracks/roh/components/RohTitle";
import RohTooltip from "../Pulsar/tracks/roh/components/RohTooltip";
import rohTrackController from "../Pulsar/tracks/roh/rohTrackController";

// Transcripts
import transcriptTrackController from "../Pulsar/tracks/transcripts/transcriptTrackController";
import TranscriptTooltip from "../Pulsar/tracks/transcripts/components/TranscriptTooltip";
import TranscriptsOverlay from "../Pulsar/tracks/transcripts/components/TranscriptsOverlay";
import TranscriptInfo from "../Pulsar/tracks/transcripts/components/TranscriptInfo";

function getCnvBrowserTracks(sampleId) {
  const {
    loadSequence,
    loadReads,
    loadCoverage,
    loadMainTranscripts,
    getRohBedFile,
  } = getApiClient();

  const tracks = [
    {
      id: "dna-cnv",
      title: "Dna",
      contentHeight: 25,
      pTop: 0,
      pBottom: 0,
      headerHeight: 0,
      isStickyTop: true,
      OverlayRenderer: dnaOverlay,
      controller: dnaTrackController,
      apiLoader: {
        apiFn: loadSequence,
        maxRange: 10000,
      },
    },
    {
      id: "cnv-calls-cnv",
      title: "CNV calls",
      contentHeight: 12,
      pTop: 5,
      pBottom: 5,
      TitleRenderer: CnvCallTitle,
      TooltipRenderer: CnvCallTooltip,
      FilterRenderer: FilterContainer,
      controller: callTrackController,
      apiLoader: {
        apiFn: loadReads,
        maxRange: Infinity,
      },
    },
    {
      id: "roh-sample",
      title: "Runs of Homozygosity",
      data: {
        sample: { id: String(sampleId) },
      },
      contentHeight: 24,
      pTop: 2,
      pBottom: 2,
      TitleRenderer: RohTitle,
      TooltipRenderer: RohTooltip,
      controller: rohTrackController,
      apiLoader: {
        apiFn: getRohBedFile,
        maxRange: Infinity,
      },
    },
    {
      id: "expected-reads-cnv",
      title: "Read Ratio",
      contentHeight: 160,
      pTop: 18,
      pBottom: 18,
      GridRenderer: HorizontalGrid,
      AxisRenderer: HorizontalGridLabels,
      TitleRenderer: ReadTitle,
      TooltipRenderer: ReadTooltip,
      controller: readTrackController,
      apiLoader: {
        apiFn: loadReads,
        maxRange: Infinity,
      },
    },
    {
      id: "coverage-cnv",
      title: "Coverage",
      contentHeight: 120,
      pTop: 15,
      pBottom: 5,
      controller: coverageTrackController,
      AxisRenderer: HorizontalGridLabels,
      GridRenderer: HorizontalGrid,
      FilterRenderer: FilterContainer,
      OverlayRenderer: CoverageOverlay,
      apiLoader: {
        apiFn: loadCoverage,
        maxRange: Infinity,
      },
    },
    {
      id: "transcript-gene-cnv",
      title: "Transcripts",
      contentHeight: 0,
      pTop: 8,
      pBottom: 8,
      FilterRenderer: FilterContainer,
      TooltipRenderer: TranscriptTooltip,
      TitleRenderer: TranscriptInfo,
      OverlayRenderer: TranscriptsOverlay,
      controller: transcriptTrackController,
      apiLoader: {
        apiFn: loadMainTranscripts,
        maxRange: Infinity,
      },
    },
    {
      id: "cnv-ex-depth-btm",
      contentHeight: 400,
      headerHeight: 0,
      controller: () => ({ onReset: () => {}, meshes: [] }),
    },
    {
      id: "overlay-cnv",
      title: "overlay",
      headerHeight: 20,
      isOverlay: true,
      contentHeight: 200,
      pTop: 0,
      pBottom: 0,
      controller: selectionTrackController,
    },
  ];

  return tracks.filter(Boolean);
}

export default getCnvBrowserTracks;
